// src/client/components.tsx
import { generatePath, Link, Navigate } from "react-router-dom";
import { jsx } from "react/jsx-runtime";
var components = () => {
  return {
    Link: ({ to, params, ...props }) => {
      const path = generatePath(typeof to === "string" ? to : to.pathname, params || {});
      return /* @__PURE__ */ jsx(Link, { ...props, to: typeof to === "string" ? path : { pathname: path, search: to.search, hash: to.hash } });
    },
    Navigate: ({ to, params, ...props }) => {
      const path = generatePath(typeof to === "string" ? to : to.pathname, params || {});
      return /* @__PURE__ */ jsx(
        Navigate,
        {
          ...props,
          to: typeof to === "string" ? path : { pathname: path, search: to.search, hash: to.hash }
        }
      );
    }
  };
};

export {
  components
};
